// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ExistingAccount_wrap__EiMGr","icon":"ExistingAccount_icon__XUkrm","title":"ExistingAccount_title__8a61t","text":"ExistingAccount_text__H3GaV"};